import { connect } from "react-redux";
import AgentAIListComponent from "../../Components/AgentAI/AgentAIListComponent";
import { setAgentAIs } from "../../Redux/Actions/AgentAIActions";

const mapStateToProps = (state) => ({
  ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
  st_AgentAIs: state.reducer.AGENT_AIS,
  SCOPES_NAMES: state.reducer.SCOPES_NAMES,
});

const mapDispatchToProps = (dispatch) => ({
  setAgentAIs: (agentAIs) => dispatch(setAgentAIs(agentAIs)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AgentAIListComponent);
